const doc = [({"en":({"js":({"shared":({"create_card":({"the_model_was_created":"The model was created"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;